import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useDecision as useDecision$1 } from '@optimizely/react-sdk';

var useDecision = function useDecision(featureFlagKey) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var overrides = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _useOptimizelyDecisio = useDecision$1(featureFlagKey, options, overrides),
    _useOptimizelyDecisio2 = _slicedToArray(_useOptimizelyDecisio, 3),
    decision = _useOptimizelyDecisio2[0],
    isClientReady = _useOptimizelyDecisio2[1],
    didTimeout = _useOptimizelyDecisio2[2];
  return [decision, isClientReady, didTimeout];
};

export { useDecision };
